import { Component, OnInit, Input, EventEmitter, Output, SimpleChange, forwardRef } from '@angular/core';
import { KeyValuePair } from '../../../models/common/keyValuePair';
import { UserService } from '../../../services/user.service';
import { AlertService } from '../../../services/alert.service';
import { ConfigurationService } from '../../../services/configuration.service';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'ztsi-role-select',
	templateUrl: './ztsi-role-select.component.html',
	styleUrls: ['./ztsi-role-select.component.css'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiRoleSelectComponent),
			multi: true
		}
	]
})
export class ZtsiRoleSelectComponent implements OnInit {

	roles: KeyValuePair[] = [
		{ key: 'BOOK_KEEPER', value: 'Book Keeper' },
		{ key: 'DRIVER', value: 'Driver' },
		{ key: 'HELPER', value: 'Helper' },
		{ key: 'MANAGER', value: 'Manager' },
		{ key: 'OPERATIONS', value: 'Operations' },
		{ key: 'TRACKING', value: 'Tracking' }
	];

	@Input('value') _value: string;
	@Input() isDisabled: boolean = false;
	@Input() nullLabel: 'Select role';

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	constructor(
		private _userService: UserService,
		private _alertService: AlertService,
		private _configurationService: ConfigurationService
	) { }

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	ngOnInit() {
		this._configurationService.getEmployeeRoles().subscribe(
			result => {
				if (result.length != undefined) {
					this.roles = result;
				}
				else {
					console.log('Invalid response from server, will use default role selections instead.');
				}
			}
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-role-select/ztsi-role-select.component.ts